<div class="modal-header">
  <h4 class="modal-title">Edit Video</h4>

  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
@if (video) {
  <div class="modal-body edit-video" ngbAutofocus>
    <div style="height: 100%; width: 100%">
      <div class="responsive-video-container m-b-30">
        @if (video.platform == "youtube") {
          <iframe [src]="url | safe" title="YouTube video player" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        }
        @if (video.platform == "vimeo") {
          <iframe [src]="url | safe" id="vimeo_frame" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
        }
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <small class="text-muted">Status</small>
        <select class="form-control" [(ngModel)]="video.status">
          <option value="approved">Approved</option>
          <option value="pending">Pending</option>
          <option value="ignored">Ignored</option>
        </select>
        <small class="text-muted">Videos will not display at all for customers unless it is Approved.</small>
      </div>
      <div class="form-group col-md-6">
        <small class="text-muted">Category</small>
        <select class="form-control" [(ngModel)]="video.brand">
          <option value="presonus">Fender Studio</option>
          <option value="fender">Fender</option>
          <option value="both">Both</option>
        </select>
      </div>
    </div>
    <myp-segmented-bar
      [white]="true"
      (selected)="selectedSection = $event.id"
      [options]="[
        {
          name: 'Video Details',
          id: 'details',
          selected: true,
        },
        {
          name: 'Tags',
          id: 'tags',
        },
        {
          name: 'Associated Products',
          id: 'products',
        },
      ]"
    ></myp-segmented-bar>
    @if (selectedSection == "details") {
      <div class="m-t-20">
        <div class="form-group">
          <small class="text-muted">Title*</small>
          <input class="form-control" [(ngModel)]="video.title" />
        </div>
        <div class="form-group">
          <small class="text-muted">Description*</small>
          <textarea type="text" name="description" style="height: 120px" id="description" [(ngModel)]="video.description" class="form-control"></textarea>
        </div>
        <div class="form-group">
          <small class="text-muted">Snippet*</small>
          <textarea type="text" name="snippet" style="height: 60px" id="snippet" [(ngModel)]="video.snippet" class="form-control"></textarea>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <small class="text-muted">Level</small>
            <select class="form-control" [(ngModel)]="videoLevel">
              <option value="-1">Not Set</option>
              <option value="0">Easy</option>
              <option value="1">Intermediate</option>
              <option value="2">Difficult</option>
              <option value="3">Expert</option>
            </select>
          </div>
          <div class="form-group col-md-6">
            <small class="text-muted">Duration* (in seconds)</small>
            <input class="form-control" [(ngModel)]="video.duration" />
          </div>
        </div>
        <div class="row">
          <div class="form-check text-left col-md-6">
            <small class="d-none d-md-block text-muted">&nbsp;</small>
            <div class="m-t-5">
              <input class="m-r-10" type="checkbox" [(ngModel)]="video.subscription_only" id="subscription_only" />
              <label class="form-check-label" for="subscription_only">Only allow subscribers to watch.</label>
            </div>
          </div>
        </div>
        <form class="row row-cols-sm-auto">
          <div class="col-12 col-sm-4">
            <small class="text-muted">Date Added</small>
            <div class="input-group">
              <input class="form-control" placeholder="yyyy-mm-dd" name="dp" [(ngModel)]="createdDate" ngbDatepicker #d="ngbDatepicker" />
              <fa-icon icon="calendar" class="btn btn-outline-secondary calendar" (click)="d.toggle()"></fa-icon>
            </div>
            <small class="text-muted">Changes the video's displayed release date and sort order.</small>
          </div>
          <div class="col-12 col-sm-4">
            <small class="text-muted">Start Date</small>
            <div class="input-group">
              <input class="form-control" placeholder="yyyy-mm-dd" name="start" [(ngModel)]="startDate" ngbDatepicker #s="ngbDatepicker" />
              <fa-icon icon="calendar" class="btn btn-outline-secondary calendar" (click)="s.toggle()"></fa-icon>
            </div>
            <small class="text-muted">Video will only display for users after this date. Leave empty to display immediately.</small>
          </div>
          <div class="col-12 col-sm-4">
            <small class="text-muted">End Date</small>
            <div class="input-group">
              <input class="form-control" placeholder="yyyy-mm-dd" name="end" [(ngModel)]="endDate" ngbDatepicker #e="ngbDatepicker" />
              <fa-icon icon="calendar" class="btn btn-outline-secondary calendar" (click)="e.toggle()"></fa-icon>
            </div>
            <small class="text-muted">Video will be removed from display after this date. Leave empty to leave up forever.</small>
          </div>
        </form>
        @if (lessons && lessons.length) {
          <hr />
          <span class="brandfont-bold">Lessons containing this video...</span>
          @for (lesson of lessons; track lesson) {
            <myp-learn-list-item [large]="false" [item]="lesson" [showCopyLink]="false" [admin]="true" (itemClickedEvent)="learnGroupClick($event)"></myp-learn-list-item>
          }
        }
        @if (folders && folders.length) {
          <hr />
          <span class="brandfont-bold">Folders containing this video...</span>
          @for (folder of folders; track folder) {
            <myp-learn-list-item [item]="folder" [large]="false" [showCopyLink]="false" [admin]="true" (itemClickedEvent)="learnGroupClick($event)"></myp-learn-list-item>
          }
        }
      </div>
    }
    @if (selectedSection == "tags") {
      <div class="m-t-20">
        @if (!video.tags || !video.tags.length) {
          <span class="text-center m-b-20 d-block">No tags have been selected for this video.</span>
        }
        <div class="form-group">
          <small class="text-muted">Start typing to add tags...</small>
          <input class="form-control" [(ngModel)]="tagQuery" (keyup.enter)="createTagIfNotExist()" />
        </div>
        @if (tagQuery && tagResults && tagResults.length) {
          <div class="tag-results">
            @for (tag of tagResults; track tag) {
              <span class="add-tag-btn m-r-5" (click)="associateTag(tag)">
                <fa-icon icon="plus-circle" class="c-green t-14"></fa-icon>
                {{ tag.title }}
              </span>
            }
          </div>
        }
        @if (tagQuery && tagResults && !tagResults.length) {
          <div class="tag-results">
            No matching tag found.
            <span class="small-btn blue" (click)="createTag(tagQuery)">Add "{{ tagQuery }}"</span>
          </div>
        }
        <div class="video-tags m-t-10">
          @for (tag of video.tags; track tag) {
            <span class="associated-tag">
              {{ tag.title }}
              <fa-icon icon="times-circle" class="m-l-5" (click)="removeTag(tag)"></fa-icon>
            </span>
          }
        </div>
      </div>
    }
    @if (selectedSection == "products") {
      <div class="m-t-20">
        <myp-content-product-association [contentId]="video.id" [contentType]="'video'" [products]="video.products"></myp-content-product-association>
        <h4 class="section-header m-t-50">
          Set as Flagship Video
          <span class="section-header-link" (click)="flagshipProductsCollapsed = !flagshipProductsCollapsed">
            {{ flagshipProductsCollapsed ? "Expand" : "Collapse" }}
            <fa-icon [icon]="'chevron-' + (flagshipProductsCollapsed ? 'up' : 'down')"></fa-icon>
          </span>
        </h4>
        Find a product below to set this video as that product's Flagship Video. This video will be displayed prominently in the product detail page.
        @if (!flagshipProductsCollapsed) {
          <div class="form-group">
            <small class="text-muted">Start typing to search products or enter a Fender product SKU...</small>
            @if (searchingFlagshipProducts) {
              <fa-icon icon="spinner" animation="spin" class="m-r-10"></fa-icon>
            }
            <input class="form-control" [(ngModel)]="flagshipProductQuery" />
          </div>
          @if (flagshipProductQuery && flagshipProductResults && flagshipProductResults.length) {
            <div class="product-results m-b-30 trans-bg border-radius10 p-10">
              <ng-container>
                @for (product of flagshipProductResults; track product) {
                  <myp-list-item [title]="product.title" [subData]="[product.DTYPE]" [includeChevron]="false" [showImage]="false">
                    <div class="button-content">
                      <fa-icon
                        [icon]="updatingFlagshipMap[product.id] ? 'spinner' : 'plus'"
                        [animation]="updatingFlagshipMap[product.id] ? spinAnimation : undefined"
                        placement="left"
                        [ngbTooltip]="'Set This Video as the Flagship Video For This Product'"
                        (click)="setAsFlagship(product)"
                        class="action green circle-icon-btn m-r-10"
                      ></fa-icon>
                    </div>
                  </myp-list-item>
                }
              </ng-container>
            </div>
          }
        }
        @if (video.flagship_products && video.flagship_products.length) {
          <div>
            <span class="t-14 gothic">This video is the Flagship Video for the following products</span>
            <ng-container>
              @for (product of video.flagship_products; track product) {
                <myp-list-item [title]="product.title" [subData]="[product.DTYPE]" [includeChevron]="false" [showImage]="false">
                  <div class="button-content">
                    <fa-icon
                      [icon]="updatingFlagshipMap[product.id] ? 'spinner' : 'minus'"
                      [animation]="updatingFlagshipMap[product.id] ? spinAnimation : undefined"
                      placement="left"
                      [ngbTooltip]="'Remove This Product'"
                      (click)="unsetAsFlagship(product)"
                      class="action red circle-icon-btn m-r-10"
                    ></fa-icon>
                  </div>
                </myp-list-item>
              }
            </ng-container>
          </div>
        }
      </div>
    }
  </div>
}

<div class="modal-footer d-flex justify-content-between">
  <div>
    @if (video.id) {
      <button type="button" class="btn btn-danger" (click)="delete()" [disabled]="deleting">{{ deleting ? "Deleting..." : ("general.delete" | translate) }}</button>
    }
  </div>
  <div>
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving">{{ saving ? "Saving..." : "Save" }}</button>
    <button type="button" class="btn btn-blank m-r-5" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
  </div>
</div>
